<template lang="pug">
footer.edital-footer
  .edital-footer__container
    img.edital-footer__logo(
      src="@/assets/icons/editais/footer-logo.svg"
      alt="SICARF"
    )

    .edital-footer__columns
      .edital-footer__column(
        v-for="coluna in colunasComLinks"
        :key="coluna.titulo"
      )
        p.edital-footer__title {{ coluna.titulo }}
        a.edital-footer__link(
          v-for="link in coluna.links"
          :key="link.label"
          :href="link.href"
        ) {{ link.label }}

    .edital-footer__bottom
      .edital-footer__social
        p.edital-footer__title Redes sociais
        .edital-footer__social-icons
          a.edital-footer__social-link(
            v-for="rede in FOOTER_REDES_SOCIAIS"
            :key="rede.label"
            :href="rede.href"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="rede.label"
          )
            img(:src="rede.icon" :alt="rede.label")

      address.edital-footer__address
        | Rod. Augusto Montenegro, km 09 s/n - Bairro: Parque Guajará - Icoaraci
        br
        | CEP: 66.821-000

  .edital-footer__bar
</template>

<script>
import { FOOTER_COLUNAS, FOOTER_REDES_SOCIAIS } from '@/constants/editaisPublico'

export default {
  name: 'EditalFooter',
  data () {
    return {
      FOOTER_REDES_SOCIAIS
    }
  },
  computed: {
    urlPortal () {
      return (process.env.VUE_APP_ROOT_PARAMETRIZAVEL_URL || '').replace(/\/$/, '')
    },
    colunasComLinks () {
      return FOOTER_COLUNAS.map(coluna => ({
        titulo: coluna.titulo,
        links: coluna.links.map(link => ({
          label: link.label,
          href: `${this.urlPortal}${link.path}`
        }))
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
$footer-primary: #1e174e;
$footer-secondary: #18c5c2;

.edital-footer {
  background-color: #e1ebec;
  color: $footer-primary;
  font-family: 'Ubuntu', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  margin-top: auto;
  padding-top: 6rem;
  width: 100%;
}

.edital-footer__container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1600px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
}

.edital-footer__logo {
  display: block;
  height: auto;
  width: 150px;
}

.edital-footer__columns {
  column-gap: 2rem;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-top: 3rem;
  row-gap: 0;
}

.edital-footer__column {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.edital-footer__title {
  font-size: 1.25rem;
  font-weight: 700;
  font-synthesis: none;
  letter-spacing: 0.01em;
  line-height: 1.75rem;
  margin: 0;
}

.edital-footer__social .edital-footer__title {
  text-transform: uppercase;
}

.edital-footer__link {
  color: inherit;
  cursor: pointer;
  display: block;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: $footer-secondary;
  }
}

.edital-footer__bottom {
  align-items: center;
  display: flex;
  gap: 6rem;
  justify-content: space-between;
  margin-top: 2rem;
}

.edital-footer__social-icons {
  align-items: center;
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.edital-footer__social-link {
  align-items: center;
  color: $footer-primary;
  display: inline-flex;
  line-height: 0;
  transition: all 0.2s ease;

  &:hover {
    color: $footer-secondary;
  }

  img {
    display: block;
    height: 24px;
    width: 24px;
  }
}

.edital-footer__address {
  color: inherit;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  margin: 0;
  text-align: right;
}

.edital-footer__bar {
  background-color: $footer-secondary;
  height: 1rem;
  margin-top: 6rem;
  width: 100%;
}

@media (max-width: 1023px) {
  .edital-footer__container {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .edital-footer__columns {
    grid-template-columns: 1fr;
  }

  .edital-footer__bottom {
    align-items: flex-start;
    flex-direction: column;
    gap: 2rem;
  }

  .edital-footer__address {
    text-align: left;
  }
}
</style>
